// extracted by mini-css-extract-plugin
export default {"cancelOrderButton":"styles_cancelOrderButton__RX6pf","fillButton":"styles_fillButton__CtrAG","buttonText":"styles_buttonText__nSXZZ","canCancel":"styles_canCancel__DdPDG"};